import type { ClassValue } from "clsx";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/** Leaf `cn` — import this (not `@repo/ui` / `lib/index`) on shell hot paths. */
export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}
